import { buildStandardChartOptions } from './standard';
import { buildTreemapChartOptions } from './treemap';
import { buildHeatmapChartOptions } from './heatmap';
import { buildTimelineChartOptions } from './timeline';

const STANDARD_CHART_TYPES = new Set(['line', 'column', 'bar', 'area']);

const isStandardChart = (chartBlock) =>
    STANDARD_CHART_TYPES.has(chartBlock?.chartType);

export const buildDataRequests = (chartBlock) =>
    (chartBlock?.propertySeriesQueries || [])
        .filter((query) => query?.dataSource?.type === 'dataset')
        .map((query) => ({
            dataset: query.dataSource.value,
            filterParams: query.filterParams || [],
            query,
        }));

export const buildChartOptions = (chartBlock, rows) => {
    if (isStandardChart(chartBlock) || chartBlock?.chartType === 'polar') {
        return buildStandardChartOptions(chartBlock, rows);
    }
    if (chartBlock?.chartType === 'treemap') {
        return buildTreemapChartOptions(chartBlock, rows);
    }
    if (chartBlock?.chartType === 'heatmap') {
        return buildHeatmapChartOptions(chartBlock, rows);
    }
    if (chartBlock?.chartType === 'timeline') {
        return buildTimelineChartOptions(chartBlock, rows);
    }
    throw new Error(`Unsupported chart type: ${chartBlock?.chartType}`);
};
